module.exports = __webpack_public_path__ + "front/img/kv_slogan.1047fe12.png";